import Models from "@models";
import { defaultInstance } from "./instances";

export const fetchAll = async (): Promise<any> =>
  await defaultInstance.get<Models.Country[]>(`/location/country/list`);
